var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "m-form-radio" }, [
    _c("input", {
      staticClass: "checkbox",
      attrs: { type: "radio", disabled: _vm.disabled },
      domProps: { checked: _vm.isChecked, value: _vm.value },
      on: {
        change: function($event) {
          return _vm.$emit("change", $event.target.value)
        }
      }
    }),
    _vm._v(" " + _vm._s(_vm.label) + " ")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }